import { cn } from "../../../lib/utils";
import { useContagemFila, usePendenciasAtendimento } from "../hooks/use-suporte";

// Contadores ao lado de "Suporte" no menu. Cada um some quando zera; a fila vem
// em páginas de 100, por isso o teto "99+".

function Contador({ valor, cor, rotulo }: { valor: string; cor: string; rotulo: string }) {
  return (
    <span
      className={cn(
        "ml-1.5 inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full px-1.5 text-xs font-semibold text-white",
        cor
      )}
      aria-label={`${valor} ${rotulo}`}
      title={rotulo.charAt(0).toUpperCase() + rotulo.slice(1)}
    >
      {valor}
    </span>
  );
}

// Âmbar: atendimentos aguardando na fila (mesma cor da aba Fila).
export function SuporteFilaBadge() {
  const { data } = useContagemFila();
  if (!data || data.total === 0) return null;
  const valor = data.total > 99 || data.temMais ? "99+" : String(data.total);
  return <Contador valor={valor} cor="bg-amber-500" rotulo="atendimentos aguardando na fila" />;
}

// Azul: atendimentos em andamento com mensagem nova do entregador (mesmo número
// do título da aba e mesma cor do ponto na lista). Sem polling próprio: lê o
// cache que o alerta do título atualiza.
export function SuporteNovasBadge() {
  const { data: pendentes = 0 } = usePendenciasAtendimento();
  if (pendentes === 0) return null;
  return (
    <Contador valor={pendentes > 99 ? "99+" : String(pendentes)} cor="bg-blue-600" rotulo="atendimentos com mensagem nova" />
  );
}

// Os dois juntos, para o item "Suporte" do menu.
export function SuporteBadges() {
  return (
    <>
      <SuporteFilaBadge />
      <SuporteNovasBadge />
    </>
  );
}
